import { CbwService } from "../../../../../apis/networkdashboard/rest/services";
import { CollectorCallbackParams } from "../collector-callback";

export function collectorLir(cbw: CbwService, customerId: string, callback: (data: CollectorCallbackParams) => void) {
  cbw.getCustomerPrefixList({ customer_id: customerId }).then((result) => {
    let data = "";
    if (Array.isArray(result)) {
      data = result.join("\n");
    }
    callback({ data });
  });
}
